<template>
  <div class="container">
    <content-template>
      <template slot="left">滙業盃專區</template>
      <template slot="right">
        <li>
          <router-link to="enrolls">線上報名</router-link>
        </li>
        <li>
          <router-link to="download">下載表格</router-link>
        </li>
        <li><a href="#" class="is-check" style="color: #5571EC;">簡介及比賽規章</a></li>
      </template>
      <template slot="banner">
        <img :src="otherDetail.banner" class="col-xs-12" style="padding:0px;" alt="">
      </template>
      <template slot="content">

        <div class="row article-content" style="padding:0px;">
          <span class="col-xs-6 news-title">簡介及比賽 </span>
          <!--<span class=" col-xs-6 ac-time">報名日期: {{otherDetail.start_time|moment("YYYY年MM月DD日")}}至{{otherDetail.end_time|moment("MM月DD日")}}</span>-->
          <span class=" col-xs-6 ac-time">報名日期: {{otherDetail.start_time * 1000|datefmt("YYYY年MM月DD日")}}至{{otherDetail.end_time * 1000|datefmt("YYYY年MM月DD日")}}</span>
        </div>
        <div class="col-xs-12">
          <div v-html="otherDetail.rule" class="article-content"></div>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      otherDetail: [],
      registerTime: ''
    }
  },
  methods: {
    getOther: function () {
      var that = this
      this.$axios.get('/huiye/other')
        .then(function (response) {
          that.otherDetail = response.data.data
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.getOther()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/huiye/huiyeRule.vue